<div class="class-zero-content">
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner class="white-spinner" color="primary" diameter="24"></mat-spinner>
      <p class="loading-text">Cargando clase introductoria...</p>
    </div>
  } @else if (!added) {
    <div class="add-button">
      <app-enfaf-button color="primary" height="52px" padding="14px 51px" [setNgStyle]="{ 'font-size': '16px' }" (onClick)="addClassZero()">
        Añadir clase introductoria
      </app-enfaf-button>
    </div>
  } @else {
    <mat-accordion>
      <mat-expansion-panel
        class="course-accordion class-accordion"
        [expanded]="expanded"
        #classZeroPanel
        (opened)="expanded = true"
        (closed)="expanded = false"
      >
        <mat-expansion-panel-header class="course-accordion__header class-header">
          <div class="course-accordion__title-container class-title-container">
            <div class="course-accordion__left">
              <div class="course-accordion__text">Clase introductoria</div>
              @if (isSaving) {
                <span class="course-accordion__saving">Guardando…</span>
              }
            </div>
            <div class="course-accordion__actions">
              <button type="button" class="course-accordion__nav-button">
                <mat-icon class="course-accordion__chevron-icon" [class.rotated]="classZeroPanel.expanded"> expand_more </mat-icon>
              </button>
            </div>
          </div>
        </mat-expansion-panel-header>

        @if (expanded) {
          <div class="class-item-content" [formGroup]="form">
            <div class="input-row">
              <div class="input-field__wrapper">
                <enfaf-input label="Nombre de la clase" placeholder="Nombre de la clase" errorLabel="Campo requerido" [control]="form.get('name')">
                </enfaf-input>
              </div>

              <div class="input-field__wrapper">
                <enfaf-input
                  label="ID de video de Vimeo"
                  placeholder="123456789"
                  [errorLabel]="form.get('videoUrl')?.hasError('pattern') ? 'El formato del ID no es válido (9 o 10 dígitos)' : 'Campo requerido'"
                  [control]="form.get('videoUrl')"
                  (paste)="onVimeoIdPaste($event)"
                >
                </enfaf-input>
              </div>
            </div>

            <div class="input-field__wrapper">
              <app-enfaf-textarea-dark label="Descripción" placeholder="Descripción de la clase introductoria" [control]="form.get('description')">
              </app-enfaf-textarea-dark>
            </div>

            @if (courseYearClassZeroId) {
              <app-admin-class-zero-notes [courseYearId]="courseYearId" (notesHasChanges)="onNotesDirtyChange($event)"></app-admin-class-zero-notes>
            }

            <div class="promotion-content">
              <div class="row">
                <app-enfaf-switch-dark
                  [control]="form.get('showPromotion')!"
                  label="Mostrar promoción en la clase introductoria"
                  (onChange)="toggleShowPromotion($event)"
                >
                </app-enfaf-switch-dark>
              </div>

              @if (form.get('showPromotion')?.value) {
                <div class="promotion-container">
                  <h3 class="promotion-title">Promoción de la clase introductoria</h3>

                  <div class="promotion-form-row">
                    <div class="promotion-form-row-split">
                      <div class="promotion-form-group">
                        <enfaf-input
                          label="Texto del botón"
                          placeholder="Texto del botón"
                          errorLabel="Campo requerido"
                          [control]="form.get('promotionButtonText')"
                          class="promotion-input"
                        ></enfaf-input>
                      </div>

                      <div class="promotion-form-group">
                        <enfaf-input
                          label="Enlace del botón"
                          placeholder="Enlace del botón"
                          [control]="form.get('promotionButtonUrl')"
                          [errorLabel]="
                            form.get('promotionButtonUrl')?.hasError('pattern') ? 'El formato del enlace no es correcto' : 'Campo requerido'
                          "
                          class="promotion-input"
                        ></enfaf-input>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>

            <div class="checkbox-field">
              <app-enfaf-checkbox [control]="form.get('hidden')">Ocultar clase introductoria</app-enfaf-checkbox>
            </div>
          </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
  }
</div>
